import { render, staticRenderFns } from "./CommentInfoView.vue?vue&type=template&id=4ceffbfc&"
import script from "./CommentInfoView.vue?vue&type=script&lang=js&"
export * from "./CommentInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ceffbfc')) {
      api.createRecord('4ceffbfc', component.options)
    } else {
      api.reload('4ceffbfc', component.options)
    }
    module.hot.accept("./CommentInfoView.vue?vue&type=template&id=4ceffbfc&", function () {
      api.rerender('4ceffbfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/statistics/durginfo-stast-view/CommentInfoView.vue"
export default component.exports